const agents = [
  {
    id: 1,
    name: 'Craig Kief',
    email: 'craigk@kiefrealty.com',
    image: '/static/images/craig.png',
    titles: ['Designated Managing Broker'],
    bio: `
      Bachelor of Science in Accountancy from the University of Illinois, with
      over 10 years of experience in both Residential Real Estate and Financial
      Accounting.
    `,
    agentId: 'MRD952108'
  },
  {
    id: 2,
    name: 'Alaina Kief',
    email: 'alainak@kiefrealty.com',
    image: '/static/images/alaina.png',
    titles: ['Licensed Broker', 'Office Manager'],
    bio: `
      Bachelor of Science in Financial Accounting from Illinois State University,
      with over 10 years of experience in Banking and Mortgage Lending.
    `,
    agentId: 'MRD950226'
  },
  {
    id: 3,
    name: 'Joe Reinhart',
    email: 'joer@kiefrealty.com',
    image: '/static/images/joe.png',
    titles: ['Licensed Broker', 'Marketing'],
    bio: `
      Bachelor in MIS from Millikin University & Masters in MIS from the University
      of Illinois, with over 10 years of experience in IT and 4 years in Property
      Management.
    `,
    agentId: 'MRD950227'
  }
]

export default agents



// WEBPACK FOOTER //
// ./src/data/agents.js